
import { Backdrop, CircularProgress, Stack } from "@mui/material";
import { Box, styled } from "@mui/system";


export const SELECT_OPTION = {
    id: "select",
    corporationName: "-Select-",
};

export const BorderBox = styled(Stack)(
    ({ theme, p, borderRadius, border }) => ({
        borderRadius: borderRadius ?? theme.shape.borderRadius * 1.5,
        padding: p ?? theme.spacing(2),
        border: border ?? `1px solid ${theme.palette.divider}`,
    })
);

export function Loader({ loading }) {
    return (
        <Backdrop
            open={loading}
            sx={(theme) => ({
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            })}
        >
            <CircularProgress />
        </Backdrop>
    );
}

export const formatDateOnly = d =>
    d ? new Date(d).toLocaleDateString("en-CA") : null;


export async function handleSessionOut() {
    const name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise(resolve => setTimeout(resolve, 500));
};